import { render, staticRenderFns } from "./DataInputList.vue?vue&type=template&id=74131858&"
import script from "./DataInputList.vue?vue&type=script&lang=js&"
export * from "./DataInputList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports